import React, { Component } from 'react';
import OfficeCntBarChart from './OfficeCntBarChart';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const COLORS = ['#3d81ff', '#fd6094'];

class OfficeCntMng extends Component {

    handleSelectedOffice = (damdangOffice, siteCnt) => {
        this.props.handleSelectedOffice(damdangOffice, siteCnt);
    };

    render() {
        const { opbOfficeCnt, selectedOffice } = this.props;
        let maxCnt = 0;
        if (opbOfficeCnt && opbOfficeCnt.length > 0) {
            opbOfficeCnt.map(office => {
                if (office.totalCnt > maxCnt) maxCnt = office.totalCnt;
                return office;
            });
        }

        return (
            <div className="dashboard-officecnt">
                <div className="dashboard-officecnt-title">지사별 설치 현황</div>
                <div className="dashboard-officecnt-contents">
                    <div className="dashboard-officecnt-label">
                            <div className="" style={{display: "inline-flex", width: "20px", height: "5px", backgroundColor: COLORS[0]}}></div>현장수
                            <div className="" style={{display: "inline-flex", width: "20px", height: "5px", backgroundColor: COLORS[1]}}></div>Display수
                    </div>
                    {opbOfficeCnt && opbOfficeCnt.length > 0 &&
                        opbOfficeCnt.map((office, i) => <OfficeCntItem key={i} office={office} maxCnt={maxCnt} isActive={selectedOffice.damdangOffice === office.damdangOffice} handleSelectedOffice={this.handleSelectedOffice} />)
                    }
                </div>
            </div>
        );
    }
}


class OfficeCntItem extends Component {
    
    handleSelectedOffice = () => {
        const { damdangOffice, siteCnt } = this.props.office;
        this.props.handleSelectedOffice(damdangOffice, siteCnt);
    };

    render() {
        const { office, maxCnt, isActive } = this.props;
        const { officeName } = office;

        return (

            <div className={`dashboard-officecnt-item ${isActive ? "active" : ""}`} onClick={this.handleSelectedOffice}>
                <OverlayTrigger placement="right" overlay={<Tooltip>{officeName}</Tooltip>}>
                    <div className="col col-4 title">
                        {officeName.indexOf("지사") > -1 ? officeName.slice(0, officeName.indexOf("지사")) : officeName.slice(0, 5)}
                    </div>
                </OverlayTrigger>
                <div className="col col-8">
                    <OfficeCntBarChart office={office} maxCnt={maxCnt + 2} />
                </div>
            </div>
        );
    }
}







export default OfficeCntMng;